import { gql } from "@apollo/client";

export const DELETE_ELIGIBILITY_MUTATION = gql`
  mutation DeleteEligibilityMutation($eligibilityId: String!) {
    deleteEligibility(eligibilityId: $eligibilityId)
  }
`;
